import featuresImg from "../../assets/images/hd-3.jpg";
import { featuresData } from "../../constants/constants";
import FAQS from "../Faqs";
import { Footer } from "../Footer";
import Hero from "../Hero";
import { Link } from "react-router-dom";
import MainNavbar from "../MainNavbar";

export default function Features() {
  return (
    <>
      <MainNavbar />
      <Hero
        bgImage={featuresImg}
        imageText={{
          title: "Our Platform Features",
          description:
            "Ohanlonip strives to provide the Mobile Marketer with a Feature Rich Platform.",
        }}
      />
      <div className="bg-white pt-10  flex-grow ">
        <div className={"w-[85%] m-auto text-left"}>
          <section>
            <div className="flex gap-4">
              {/* Left column: feature titles with anchor links */}
              <div className="w-1/3 space-y-4">
                {featuresData?.map((feature, index) => (
                  <div key={index}>
                    <a href={`#feature-${index}`} className="text-black py-2 block  cursor-pointer">
                      {feature?.featureTitle}
                    </a>
                  </div>
                ))}
              </div>

              {/* Right column: feature descriptions with ids */}
              <div className="w-2/3 space-y-4">
                {featuresData?.map((feature, index) => (
                  <div key={index} id={`feature-${index}`}>
                    <img
                      className="max-w-[128px] brightness-120 hover:brightness-75 transition duration-300"
                      src={feature?.icon}
                      alt="icon"
                    />
                    <p className="text-[#3b4455] mt-2 text-xl">{feature.featureTitle}</p>
                    <p className="text-[#3b4455] mt-1">
                      {feature.featureDescription}
                      {feature.linkText && feature.linkTo && (
                        <Link
                          to={feature.linkTo}
                          className="text-blue-600 hover:text-blue-800 ml-1"
                        >
                          {feature.linkText}
                        </Link>
                      )}
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </section>
        </div>
        <div className="pt-5">
          <FAQS />
        </div>
        <Footer />
      </div>
    </>
  );
}
